// src/components/inputs/SelectAutoComplacent.jsx
import { Autocomplete, TextField, useTheme } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import React from 'react';
// import { makePreview } from '../../utils/helpers'; // ❌ لم نعد بحاجة لهذا هنا
import { useTranslation } from 'react-i18next';

const SelectAutoComplacent = ({
  name,
  value,
  options,
  onChange,
  disabled,
  sx,
  error,
  helperText
}) => {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const lng = i18n.language || 'en';
  const isArabic = lng === 'ar';

  // ✅ تعديل دالة جلب الاسم لإظهار النص كاملاً
  const getLabel = (opt) => {
    if (!opt?.name) return '';

    // إذا كان الاسم نصاً مباشراً
    if (typeof opt.name === 'string') {
      // ❌ القديم: return makePreview(opt.name, 40) ?? '';
      return opt.name ?? ''; // ✅ الجديد: إرجاع النص كاملاً
    }

    // إذا كان الاسم كائناً (متعدد اللغات)
    if (typeof opt.name === 'object') {
      const nameStr = isArabic
        ? (opt.name.ar || opt.name.en || '')
        : (opt.name.en || opt.name.ar || '');

      // ❌ القديم: return makePreview(nameStr, 40) ?? '';
      return nameStr ?? ''; // ✅ الجديد: إرجاع النص كاملاً
    }

    return '';
  };

  return (
    <Autocomplete
      id={`${name}-autocomplete`}
      options={options ?? []}
      getOptionLabel={getLabel}
      isOptionEqualToValue={(option, val) =>
        String(option?.id) === String(val?.id ?? val ?? '')
      }
      value={options?.find((o) => String(o.id) === String(value ?? '')) ?? null}
      onChange={(_, newVal) => {
        if (!onChange) return;
        const syntheticEvent = {
          target: {
            name,
            value: newVal ? newVal.id : '',
          },
        };
        onChange(syntheticEvent);
      }}
      disabled={disabled}
      clearOnEscape
      disableClearable={false}
      popupIcon={<ArrowDropDownIcon />}
      sx={{
        width: '100%',
        mt: 1,
        minWidth: '80px',
        '& .MuiAutocomplete-endAdornment': {
          right: isArabic ? 'auto !important' : '9px !important',
          left: isArabic ? '9px !important' : 'auto !important',
        },
        '& .MuiAutocomplete-clearIndicator': {
          marginRight: isArabic ? 'auto' : undefined,
          marginLeft: isArabic ? 0 : 'auto',
        },
        '& .MuiAutocomplete-popupIndicator': {
          marginRight: isArabic ? 'auto' : undefined,
          marginLeft: isArabic ? 0 : 'auto',
        },
        ...sx,
      }}

      // ✅ تحسين عرض القائمة (List) لضمان التفاف النص الطويل (Wrapping)
      renderOption={(props, option) => {
        return (
          <li {...props} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {getLabel(option)}
          </li>
        );
      }}

      ListboxProps={{
        sx: {
          maxHeight: 320,
          direction: isArabic ? 'rtl' : 'ltr',
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          error={!!error}
          helperText={error || helperText}
          InputProps={{
            ...params.InputProps,
            sx: {
              height: 40,
              backgroundColor: theme.palette.background.input,
              borderRadius: 1,
              direction: isArabic ? 'rtl' : 'ltr',
              paddingRight: isArabic ? '9px !important' : '39px !important',
              paddingLeft: isArabic ? '39px !important' : '9px !important',
              '& input': {
                padding: '0 !important',
                textAlign: isArabic ? 'right' : 'left',
                '&::placeholder': {
                  textAlign: isArabic ? 'right' : 'left',
                },
              },
            },
          }}
        />
      )}
    />
  );
};

export default SelectAutoComplacent;